import React, { FC } from 'react';
import { Chip, Grid, Typography } from '@material-ui/core';

const SimpleChipInfo: FC<SimpleTextInfoProps> = (props) => {
	const { compact, label, value } = props;
	const testidPrefix = label.toLowerCase();

	if (!value || value.length === 0) return null;

	return (
		<Grid container item>
			<Grid item xs={compact ? 12 : 3} data-testid={`${testidPrefix}-label`}>
				<Typography variant='subtitle2'>{label}</Typography>
			</Grid>
			<Grid item xs={compact ? 12 : 9} data-testid={`${testidPrefix}-value`}>
				{value && value.map((chip: string) => <Chip label={chip} color='primary' style={{ marginRight: 4 }} />)}
			</Grid>
		</Grid>
	);
};

export type SimpleTextInfoProps = {
	compact?: boolean;
	label: string;
	value: string[] | null | undefined;
};

export default SimpleChipInfo;
